export type FinancingOperation = 'constitution' | 'payInstallments' | 'shortTermDebt';

export interface FinancingDetailAction {
  type: FinancingOperation | 'changed';
  editUid?: string;
}

export interface FinancingDetailRow {
  uid: string;
  descripcion: string;
  importeInicial: number;
  importePendiente: number;
  duracion: number;
  fechaConstitucion: Date | string;
  fechaFinalizacion: Date | string;
  accountingModelsCortoPlazoNumber?: string;
  accountingModelsLargoPlazoNumber?: string;
  partnersName?: string;
  __detailVersion?: number;
}

export interface FinancingDetailConstitution {
  uid: string;
  fecha: Date | string;
  concepto: string;
  importe: number;
  comisionApertura: number;
  gastosBancarios: number;
  bankAccountInfo: string;
}

export interface FinancingDetailPayment {
  uid: string;
  fecha: Date | string;
  concepto: string;
  importeCapital: number;
  intereses: number;
  gastosBancarios: number;
  bankAccountInfo: string;
}

export interface FinancingDetailShortTermDebt {
  uid: string;
  fecha: Date | string;
  concepto: string;
  importe: number;
  activitiesName?: string;
}

export interface FinancingDetailData {
  constituciones: FinancingDetailConstitution[];
  pagos: FinancingDetailPayment[];
  deudas: FinancingDetailShortTermDebt[];
}

export type FinancingDetailLoader = (uid: string) => Promise<FinancingDetailData>;

export type FinancingDetailDeleter = (operation: FinancingOperation, uid: string) => Promise<unknown>;

export const FINANCING_SHORT_TERM = 1;
export const FINANCING_LONG_TERM = 2;

export function financingTermLabel(duracion: number): string {
  if (duracion === FINANCING_SHORT_TERM) return 'Corto plazo';
  if (duracion === FINANCING_LONG_TERM) return 'Largo plazo';
  return 'Sin plazo';
}

export function isFinancingAmortized(row: { importeInicial: number; importePendiente: number }): boolean {
  return (Number(row.importeInicial) || 0) > 0 && (Number(row.importePendiente) || 0) <= 0;
}

export function stripFinancingConcept(concept: string, parentDescription: string): string {
  let text = concept || '';
  if (!parentDescription) return text;
  const head = parentDescription + ' - ';
  while (text.startsWith(head)) {
    text = text.substring(head.length);
  }
  return text;
}

export interface FinancingListFilter {
  page: number;
  pageSize: number;
  search: string;
  sortField: string;
  sortDirection: string;
}

export interface FinancingListSummary {
  initialAmount: number;
  outstandingAmount: number;
}

export interface FinancingListResult<T> {
  items: T[];
  total: number;
  summary: FinancingListSummary;
}

export const EMPTY_FINANCING_LIST_SUMMARY: FinancingListSummary = { initialAmount: 0, outstandingAmount: 0 };
